module.exports = __webpack_public_path__ + "static/media/fortoyningsboye.85ec02b4.svg";